import { render, staticRenderFns } from "./SettingsAddUpdate.vue?vue&type=template&id=55d1fc00&"
import script from "./SettingsAddUpdate.vue?vue&type=script&lang=js&"
export * from "./SettingsAddUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports